
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import PolicyOverview from './components/PolicyOverview';
import PersonalInfo from './components/PersonalInfo';
import HouseholdMembers from './components/HouseholdMembers';
import Billing from './components/Billing';
import Documents from './components/Documents';
import ChatWidget from '../../components/feature/ChatWidget';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const navigate = useNavigate();

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <PolicyOverview />;
      case 'personal':
        return <PersonalInfo />;
      case 'household':
        return <HouseholdMembers />;
      case 'billing':
        return <Billing />;
      case 'documents':
        return <Documents />;
      default:
        return <PolicyOverview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Home Button */}
      <button
        onClick={() => navigate('/')}
        className="fixed top-6 right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
        title="Go to Home"
      >
        <i className="ri-home-line text-xl w-6 h-6 flex items-center justify-center"></i>
      </button>

      <Header />
      <div className="flex">
        <main className="flex-1 p-6">
          {renderContent()}
        </main>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      <ChatWidget 
        apiEndpoint="https://voice.theinsurancedoctors.com/readdy-chat"
        apiKey=""
        agentName="Dr. Peterson's AI Assistant"
        welcomeMessage="Hi! I'm Dr. Peterson's AI assistant. How can I help today?"
      />
    </div>
  );
}
